import type {
  AssistantFunction,
  AssistantToolsObject,
} from "../../../services/api/instances/assistantsApi/types";

export const addSelectedFieldToFunctions = (
  functions: AssistantFunction[],
  tools: AssistantToolsObject[],
): AssistantFunction[] => {
  return functions.map((_function) => {
    const isFunctionSelected = tools.find(
      (tool) =>
        tool.type === "function" &&
        tool.function?.name === _function.function_name,
    );
    return {
      ..._function,
      selected: !!isFunctionSelected,
    };
  });
};
